class URLParamsHelper {
  static update (param, value) {
    const searchParams = new URLSearchParams(window.location.search)
    searchParams.set(param, value)

    const newPath = window.location.pathname + '?' + searchParams.toString()
    window.history.replaceState(null, null, newPath)
  }
}

export default URLParamsHelper
